import { useState } from "react";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";

const AdminLogin = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      if (!err?.response) {
        console.error("Admin login network/CORS error:", err?.message);
        setError("Could not reach the server. Please check your connection and try again.");
      } else {
        setError(apiError(err, "Login failed. Please try again."));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-espresso px-4">
      <div className="grain-overlay" />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-sm border border-gold/25 bg-espresso-surface p-8 sm:p-10"
      >
        <div className="text-center">
          <p className="font-accent text-2xl font-bold tracking-[0.35em] text-cream">AARMIRA</p>
          <p className="mt-2 font-mono text-[9px] uppercase tracking-[0.3em] text-gold-muted">
            Atelier Admin
          </p>
        </div>
        <form data-testid="admin-login-form" onSubmit={handleSubmit} className="mt-8 space-y-4">
          <input
            data-testid="admin-username-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Admin email"
            autoComplete="username"
            className="w-full border border-cream/15 bg-transparent px-4 py-3 text-sm text-cream outline-none transition-colors placeholder:text-cream/30 focus:border-gold"
          />
          <input
            data-testid="admin-password-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            autoComplete="current-password"
            className="w-full border border-cream/15 bg-transparent px-4 py-3 text-sm text-cream outline-none transition-colors placeholder:text-cream/30 focus:border-gold"
          />
          {error && (
            <p data-testid="admin-login-error" className="text-xs text-red-400">
              {error}
            </p>
          )}
          <button
            data-testid="admin-login-submit-button"
            type="submit"
            disabled={loading}
            className="w-full bg-gold py-3.5 font-mono text-[11px] uppercase tracking-[0.3em] text-espresso transition-all duration-300 hover:bg-gold-accent active:scale-[0.98] disabled:opacity-50"
          >
            {loading ? "Unlocking…" : "Enter the Atelier"}
          </button>
        </form>
      </motion.div>
    </main>
  );
};

export default AdminLogin;
